import { useEffect, useState } from "react";
import "./styles.css";

import { ArrowForwardIosRounded, ArrowForwardRounded, ArrowRightRounded, ChevronRightRounded } from "@material-ui/icons";

export default function OptionsControl({ config }) {
    const [value, setValue] = useState(config.options[0].value)

    useEffect(() => {
        setTimeout(() => {
            handleValueChange(value)
        }, 50)
    }, [value])

    function handleValueChange(val) {
        const controlEvent = new CustomEvent('control.' + config.id, {
            bubbles: true,
            cancelable: true,
            detail: { // Custom data to pass with the event
                value: val,
            }
        });
        window.dispatchEvent(controlEvent);
    }

    return (
        <div
            className={"options-control " + (config.variant || 'LIIGHT')}
            style={{ ...(config.style || {}) }}
        >
            {
                config.options.map((opt, i) => (
                    <div
                        onClick={() => setValue(opt.value)}
                        className={"control-option " + (opt.value === value && 'active')}
                        key={"Option-control-" + i + opt.value}>
                        <p>{opt.label}</p>
                    </div>
                ))
            }
        </div>
    );
}